import styled, { css } from 'styled-components'
import { ModalHeader } from 'modules/projects/components/SelectDropdown/SelectList/SelectList.styles'
export {
  BackButton,
  BackIcon,
} from 'modules/shares/ComponentsWebView/components/Sidebar/MobileGroupsDropdown.styles'
export {
  ModalFooter,
  CancelButton,
} from 'modules/projects/components/SelectDropdown/SelectList/SelectList.styles'

export const MobileNavigationHeader = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.D};
    font-weight: ${theme.fontWeights.semibold};
    font-size: ${theme.fontSizes.B};
    text-transform: uppercase;
    margin-left: 8px;
    margin-top: 12px;
  `
)

export const TallerModalHeader = styled(ModalHeader)`
  padding: 10px 0; /* stylelint-disable-line scales/space */
`
